import script from "./EmailVerifyWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerifyWarning.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerifyWarning.vue?vue&type=style&index=0&id=d76e0922&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d76e0922"]])

export default __exports__